import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react"
import { currentUrl } from "../../../url"

export const counterpartiesApi = createApi({
  reducerPath: "counterpartiesApi",
  tagTypes: ["Counterparty"],
  refetchOnMountOrArgChange: true,
  baseQuery: fetchBaseQuery({
    baseUrl: currentUrl,
    prepareHeaders: (headers) => {
      const accessToken = localStorage.getItem("accessToken")
      if (accessToken) {
        const token = accessToken.startsWith("Bearer ")
          ? accessToken
          : `Bearer ${accessToken}`
        headers.set("Authorization", token)
        headers.set("Accept", "application/json")
        headers.set("Content-Type", "application/json")
      }
      return headers
    },
  }),
  endpoints: (build) => ({
    // GET /finance/counterparties?page=1
    getCounterparties: build.query({
  query: (params = {}) => {
    const { page = 1, per_page = 10 } = typeof params === 'number' ? { page: params } : params
    return `/master/finance/counterparties?page=${page}&per_page=${per_page}`
  },
      providesTags: (result) =>
        result?.data
          ? [
              ...result.data.map(({ id }) => ({ type: "Counterparty", id })),
              { type: "Counterparty", id: "LIST" },
            ]
          : [{ type: "Counterparty", id: "LIST" }],
    }),

    // GET /finance/counterparties/{id}
    getCounterparty: build.query({
      query: (id) => `/master/finance/counterparties/${id}`,
      providesTags: (result, error, id) => [{ type: "Counterparty", id }],
    }),

    // POST /finance/counterparties
    createCounterparty: build.mutation({
      query: (body) => ({
        url: `/master/finance/counterparties`,
        method: "POST",
        body,
      }),
      invalidatesTags: [{ type: "Counterparty", id: "LIST" }],
    }),

    // PATCH /finance/counterparties/{id}
    updateCounterparty: build.mutation({
      query: ({ id, ...body }) => ({
        url: `/master/finance/counterparties/${id}`,
        method: "PATCH",
        body,
      }),
      invalidatesTags: (result, error, { id }) => [
        { type: "Counterparty", id: "LIST" },
        { type: "Counterparty", id },
      ],
    }),

    // DELETE /finance/counterparties/{id}
    deleteCounterparty: build.mutation({
      query: (id) => ({
        url: `/master/finance/counterparties/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: (result, error, id) => [
        { type: "Counterparty", id: "LIST" },
        { type: "Counterparty", id },
      ],
    }),
  }),
})

export const {
  useGetCounterpartiesQuery,
  useGetCounterpartyQuery,
  useCreateCounterpartyMutation,
  useUpdateCounterpartyMutation,
  useDeleteCounterpartyMutation,
} = counterpartiesApi
